import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

export interface GitLabListPageProps extends NSARouterMakerResult, CredentialProps { }

class GitLabListPage extends Component<GitLabListPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section lists all the GitLab credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
                }}
                pages={{
                    entity: CredentialEntities.git_lab(this.props),
                    list: {
                        ui: {}
                    }
                }}
            >
                <></>
            </CredentialLayout >
        );
    }
}

export default GitLabListPage;